import firebase from "firebase/app";
import "firebase/auth";

const firebaseConfigRed = {
  apiKey: "AIzaSyC1phWBoW_mcGyOdac8VDW6Z_UBkyPSyPY",
  authDomain: "medoptic-dev.firebaseapp.com",
  databaseURL: "https://medoptic-dev.firebaseio.com",
  projectId: "medoptic-dev",
  storageBucket: "medoptic-dev.appspot.com",
  messagingSenderId: "294582149809",
  appId: "1:294582149809:web:11af7df30401b187aab890",
  measurementId: "G-GV5LPYYD65",
};

const firebaseConfigGold = {
  apiKey: "AIzaSyD3TrIMg_9_CpOw7G6xWssTC16V1eByP_I",
  authDomain: "medoptic-gold.firebaseapp.com",
  databaseURL: "https://medoptic-gold-default-rtdb.firebaseio.com",
  projectId: "medoptic-gold",
  storageBucket: "medoptic-gold.appspot.com",
  messagingSenderId: "613943485580",
  appId: "1:613943485580:web:778b254a27133d7e2487a9",
  measurementId: "G-ZZCLL2ZSX5",
};

const firebaseConfigProduction = {
  apiKey: "AIzaSyAcmi0yKe04FUrLUPO_WNADe_jx_f7NS8E",
  authDomain: "medoptic-61ea9.firebaseapp.com",
  databaseURL: "https://medoptic-61ea9.firebaseio.com",
  projectId: "medoptic-61ea9",
  storageBucket: "medoptic-61ea9.appspot.com",
  messagingSenderId: "1046312995803",
  appId: "1:1046312995803:web:5be647b7971a705fea35fe",
  measurementId: "G-BFKP6LZE2R",
};

switch (process.env.REACT_APP_ENVIRONMENT) {
  case "production":
    firebase.initializeApp(firebaseConfigProduction);
    break;
  case "gold":
    firebase.initializeApp(firebaseConfigGold);
    break;
  default:
    firebase.initializeApp(firebaseConfigRed);
}
export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();
